import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { Container } from '../../../components/commons'
import Table from '../../../components/Table'
import Pagination from '../../../components/Table/Pagination'
import { api } from '../../../services/api'
import TableActions from '../../../components/Table/TableActions'
import ModalDelete from '../../../components/Modals/ModalDelete'
import CreateModal from './CreateModal'
import { NamePhoto } from './styles'
import { format, isValid } from 'date-fns'
import useGroups, { Group } from '../../../services/groups.service'

export interface GroupsProps {}
export type ModalDeleteRef = React.ElementRef<typeof ModalDelete>
type CreateRef = React.ElementRef<typeof CreateModal>

const Groups: React.FunctionComponent<GroupsProps> = () => {
  const [page, setPage] = React.useState<number>(1)
  const [search, setSearch] = React.useState('')
  const [loading, setloading] = React.useState(false)

  const [sort, setSort] = React.useState<any>({ name: 'asc' })

  const { isLoading, data, refetch } = useGroups(page, 18, search, sort)

  const modalCreate = React.useRef<CreateRef>(null)
  const modalDeleteRef = React.useRef<ModalDeleteRef>(null)

  const onSearch = (value: string) => {
    setSearch(value)
  }

  const handleSubmitActive = async (_id: string, active: boolean) => {
    await api.put(`/groups/${_id}`, { active })

    refetch()
  }

  const onSortElement = (name: string, sort: string) => {
    setSort({ [name]: sort })
  }

  const handleCreate = () => {
    modalCreate.current?.openFormModal()
  }

  const handleOpenEdit = (initialData?: Group) => {
    modalCreate.current?.openFormModal(initialData)
  }

  const handleSubmitDelete = async (_id?: string) => {
    try {
      setloading(true)
      await api.delete(`/groups/${_id}`)
      modalDeleteRef.current?.closeModal()
      refetch()
    } catch (error) {
    } finally {
      setloading(false)
    }
  }

  const columnHelper = createColumnHelper<Group>()

  const pageChangeHandler = (page: number) => setPage(page)
  const columns = [
    columnHelper.accessor('name', {
      header: () => 'Nome',
      cell: (info) => {
        return <NamePhoto>{info.getValue()}</NamePhoto>
      },
    }),
    columnHelper.accessor('createdAt', {
      header: () => 'Data de criação',
      cell: (info) => {
        try {
          const dateValue = info?.renderValue();
          if (dateValue) {
            const date = new Date(dateValue);
            if (isValid(date)) {
              return format(date, 'dd/MM/yyyy HH:mm');
            }
          }
          return '-';
        } catch (error) {
          console.warn('Erro ao formatar data de grupo:', error);
          return '-';
        }
      },
    }),
    columnHelper.accessor('_id', {
      header: () => 'Ação',
      cell: (info) => {
        return (
          <TableActions
            isActive={info.row.original.active}
            handleActive={() => handleSubmitActive(info.row.original._id, true)}
            handleDesactive={() => handleSubmitActive(info.row.original._id, false)}
            handleEdit={() => handleOpenEdit(info.row.original)}
            handleDelete={() => modalDeleteRef.current?.openModal(info.row.original._id)}
          />
        )
      },
    }),
  ]

  return (
    <Container>
      <CreateModal ref={modalCreate} reload={refetch} />

      <ModalDelete
        loading={loading}
        title='Deletar Grupo?'
        ref={modalDeleteRef}
        onSubmitButton={handleSubmitDelete}
      />

      <Table
        title='Grupos'
        onSearch={onSearch}
        isLoading={isLoading}
        onSort={onSortElement}
        create={handleCreate}
        columns={columns}
        data={data?.data}
      />
      <Pagination
        totalPages={data?.totalPages}
        page={page}
        perPage={18}
        pageChangeHandler={pageChangeHandler}
      />
    </Container>
  )
}

export default Groups
